export default __webpack_public_path__ + "static/media/loading.9ab2a567.gif";